import { Injectable } from '@angular/core';
import { Questions } from 'src/app/models/data/stat-questions.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { StatsAnswer } from 'src/app/models/data/stat-answer.model';
import { environment } from './../../../environments/environment';
import { User } from 'src/app/models/data/user.model';
import { DropdownService } from '../dropdown/dropdown.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionsService {
  pageSection = new Subject<Questions[]>();
  questions!: Questions[];
  localUser!: User;

  constructor(
    private http: HttpClient,
    private dropdownService: DropdownService,
  ) { }

  getPage(pageNumber: number) {
    const page = pageNumber + 1;
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http
      .get(`${environment.apiUrl}/QA/page/${page}`, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          this.questions = <Questions[]>res;
          console.log(this.questions);
          this.pageSection.next(this.questions);
        }),
      );
  }

  getUserData() {
    const user: {
      username: string;
      token: string;
      status: number;
    } = JSON.parse(localStorage.getItem('user') as string);
    this.localUser = user;
  }

  updateAnswers(answerArray: StatsAnswer[]) {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http
      .put(`${environment.apiUrl}/QA`, answerArray, {
        headers: headers,
      })
      .subscribe((res) => {
        console.log(res);
        this.dropdownService.setPageCompletionStatuses();
      });
  }

  updateSingleAnswer(questionNum: number, answer: string, updatePageStatus: boolean = true) {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });

    // For Type 1 questions, send -1 instead of empty string to represent unanswered state
    // This follows backend convention where AnswerStat = -1 means incomplete
    let answerToSend = answer;
    if (answer === '' || answer === null || answer === undefined) {
      answerToSend = '-1';
    }

    const singleAnswer = new StatsAnswer(questionNum, answerToSend);
    return this.http
      .put(`${environment.apiUrl}/QA`, [singleAnswer], {
        headers: headers,
      })
      .subscribe({
        next: (res) => {
          console.log('Single answer updated:', res);
          if (updatePageStatus) {
            this.dropdownService.setPageCompletionStatuses();
          }
        },
        error: (error) => {
          console.error('Error updating single answer:', error);
          // Log the full error for debugging
          if (error.error) {
            console.error('Error details:', error.error);
          }
        }
      });
  }

  getSection() {
    return this.pageSection.asObservable();
  }
}
